export default "__VITE_ASSET__HZBqodUe__"